import { Box, CloseButton, Divider, Heading, Flex, Truncated } from '@customerio/pluma-components/react';
import type { ReactNode } from 'react';
import * as styles from './index.css';
import { headerTitleAdjacentToSuffix } from './header-title-adjacent.css';

export interface SidebarHeaderProps {
  title: ReactNode;
  /** Shown after the title (e.g. badges). Omit when unused so flex gap does not reserve space. */
  titleSuffix?: ReactNode;
  leadingActions?: ReactNode;
  trailingActions?: ReactNode;
  onClose: () => void;
}

export function SidebarHeader({ title, titleSuffix, leadingActions, trailingActions, onClose }: SidebarHeaderProps) {
  return (
    <>
      <Flex alignItems="center" justifyContent="space-between" p="100" pl="200" className={styles.sidebarHeader}>
        <Flex alignItems="center" gap="100" minW="0" flex={1}>
          {leadingActions}
          {titleSuffix != null ? (
            <Flex alignItems="center" gap="100" minW="0" flex={1}>
              <Box className={headerTitleAdjacentToSuffix}>
                <Truncated as={Heading} level="4">
                  {title}
                </Truncated>
              </Box>
              {titleSuffix}
            </Flex>
          ) : (
            <Truncated as={Heading} level="4">
              {title}
            </Truncated>
          )}
        </Flex>
        <Flex alignItems="center" gap="100" flexShrink="0">
          {trailingActions}
          <CloseButton onClick={onClose} />
        </Flex>
      </Flex>
      <Divider />
    </>
  );
}
